<template>
  <Confirm
    :show="show"
    @close="close"
  >
    <template slot="confirm-header">
      Eşleşen Ürün
    </template>
    <template slot="confirm-body">
      <Alert>
        Girmiş olduğunuz barkod ile sistemimizde kayıtlı ürün bulunmaktadır.
        Ürünü Listeleme Ekle butonu ile aşağıdaki ürünü listenize ekleyip satışa açabilir ya da
        barkodunuzu kontrol ederek düzenleyebilirsiniz.
      </Alert>

      <Alert v-if="getMinMaxInfo.length">
        {{ getMinMaxInfo }}
      </Alert>

      <div class="product-detail">
        <div class="product-item">
          <div class="product-image">
            <ListImage
              :src="product.image"
              width="100%"
            />
          </div>
          <div class="product-content">
            <div class="product-name">
              {{ product.title }}
            </div>
            <ul class="product-attributes">
              <template v-if="product.dataAttributes && product.dataAttributes.length > 0">
                <li
                  v-for="(alias, i) in product.dataAttributes"
                  :key="i"
                >
                  <span>{{ alias.name }}:</span> {{ alias.valueName || alias.customValue }}
                </li>
              </template>
            </ul>
          </div>
        </div>
        <ul class="product-properties">
          <li>
            <span>BARKOD</span>
            <span>{{ product.barcode || '-' }}</span>
          </li>
        </ul>
        <section>
          <div class="row">
            <label class="label">
              {{ $t('singleProduct.productSaleInfo.labels.stockCode') }}
            </label>
            <div>
              <input
                type="text"
                class="form-control"
                v-model="product.stockCode"
                :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.stockCode')"
              >
            </div>
          </div>
          <div class="row">
            <label class="label">
              {{ $t('singleProduct.productSaleInfo.labels.salePrice') }}
              <span class="required">*</span>
            </label>
            <div>
              <GInputPrice
                v-validate="{ required: true, isLth: product.listPrice }"
                v-model="product.salePrice"
                name="salePrice"
                @focus="setCaretPosition"
                :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.salePrice')"
                :class="{'is-invalid' : errors.has('salePrice')}"
              />
              <div class="invalid-feedback">
                {{ errors.first('salePrice') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="label">
              {{ $t('singleProduct.productSaleInfo.labels.stockCount') }}
              <span class="required">*</span>
            </label>
            <div>
              <GInputQuantity
                v-model="product.quantity"
                name="quantity"
                @focus="setCaretPosition"
                v-validate="{ required: true, configMax: true }"
                :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.stockCount')"
                :class="{'is-invalid' : errors.has('quantity')}"
              />
              <div class="invalid-feedback">
                {{ errors.first('quantity') }}
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="button-container">
        <div>
          <button
            class="btn btn-trendyol"
            @click="onConfirmSubmit"
          >
            ÜRÜN LİSTELEME EKLE
          </button>
        </div>
        <div>
          <button
            class="btn btn-secondary"
            @click="close"
          >
            BARKODU DÜZENLE
          </button>
        </div>
      </div>
    </template>
  </Confirm>
</template>

<script>
import Confirm from '@/components/Confirm';
import ListImage from '../../Product/Components/ListImage';
import setCaretPosition from '@/mixins/setCaretPosition';
import InputMask from '@/directives/InputMask';
import GInputPrice from '@trendyol-js/grace/core/GInputPrice';
import GInputQuantity from '@/components/GInputQuantity';
import Alert from '@/components/Alert';
import format from '@/utils/format';
import { mapActions } from 'vuex';

export default {
  name: 'PopupConfirmProduct',
  components: { Alert, ListImage, Confirm, GInputPrice, GInputQuantity },
  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    product: {
      type: Object,
      default: () => ({
        image: '',
      }),
    },
    index: {
      type: Number,
      default: () => 0,
    },
    badgePrices: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    mask: InputMask,
  },
  mixins: [setCaretPosition],
  methods: {
    ...mapActions({
      createProductBarcode: 'singleProduct/createProductBarcode',
    }),
    async validate () {
      const validationResult = await this.$validator.validateAll();
      return validationResult;
    },
    async onConfirmSubmit () {
      const validationResult = await this.validate();
      if (validationResult) {
        await this.createProductBarcode(this.product);
        this.$emit('removeProductVarianter', this.index);
        this.$emit('onSuccess');
        this.$emit('close');
      }
    },
    close () {
      this.$emit('close');
    },
  },
  computed: {
    getMinMaxInfo () {
      if (Object.keys(this.badgePrices).length === 0) {
        return '';
      }

      if (Object.keys(this.product).length === 0) {
        return '';
      }

      let salePrice = this.product.salePrice;
      salePrice = format.priceToNumber(salePrice);
      const { minPrice, maxPrice } = this.badgePrices;
      if (minPrice && maxPrice) {
        if (salePrice < minPrice) {
          return 'Talebiniz alınmıştır. Ürün fiyatı, bu ürüne özgü hesapladığımız minimum fiyattan düşüktür. Ürününüz bu sebepten kitlenebilir.';
        } else if (salePrice > maxPrice) {
          return 'Talebiniz alınmıştır. Ürün fiyatı, bu ürüne özgü hesapladığımız maksimum fiyattan yüksektir. Ürününüz bu sebepten kitlenebilir.';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-detail {
    .product-item {
      padding: 20px 0;
      overflow: hidden;
      border-bottom: 1px solid #dee0eb;
      display: flex;
      .product-content {
        flex: 1;
        padding-left: 15px;

        .product-name {
          font-size: 13px;
          font-weight: 500;
          color: #273142;
          height: 64px;
          line-height: 1.4;
          overflow: hidden;
        }
        .product-attributes {
          list-style: none;
          margin: 0;
          padding: 0;
          font-size: 13px;

          li {
            color: #273142;
            margin-bottom: 3px;

            span {
              color: #95a1b5;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .product-image {
        flex: 1;
        max-width: 65px;
        max-height: 100%;
        overflow: hidden;

        img {
          width: 100%;
        }
      }
    }
    .product-properties {
      margin: 0;
      padding: 0;
      list-style: none;
      margin-bottom: 15px;

      li {
        padding: 15px 0;
        border-bottom: 1px solid rgb(220, 222, 228);
        display: flex;
        align-items: center;
        span {
          font-size: 14px;
          flex: 1;
          color: rgb(110, 119, 135);

          &:last-child {
            font-weight: 500;
            color: rgb(39, 49, 66);
            text-align: right;
          }
        }
      }
    }
  }
  .button-container{
    margin-top: 20px;
    & > div{
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .btn {
        display: block;
        width: 100%;
        margin: 0 auto;
      }
    }
  }
</style>
